interface IStatusBadgeProps {
  status: 'Active' | 'Inactive';
}

const StatusBadge = ({ status }: IStatusBadgeProps) => {
  const baseClasses =
    'inline-block px-2 py-0.5 rounded-full font-medium text-center whitespace-nowrap';

  const statusClasses =
    status === 'Active'
      ? 'bg-emerald-100 text-emerald-800 text-sm'
      : 'bg-amber-100 text-amber-800 text-sm';

  return (
    <span className={`${baseClasses} ${statusClasses}`} data-status={status.toLowerCase()}>
      {status}
    </span>
  );
};

export default StatusBadge;
